export class SendDocumentResponse {
  file: string;
  url: string;
}
